<template>
  <form>
    <b-tooltip
      label="Titel, toont nergens op de MWP"
      multilined>
      <i class="info-icon">
        i
      </i>
    </b-tooltip>
    <b-field
      :type="{'is-danger': errors.has('title')}"
      :message="errors.first('title')"
      label="First name">
      <b-input
        v-model="header.title"
        v-validate="'required'"
        name="title" />
    </b-field>
    <b-tooltip
      label="Tekst in knop, default is 'ONTDEK MEER'. Hoofdletters toevoegen niet nodig"
      multilined>
      <i class="info-icon">
        i
      </i>
    </b-tooltip>
    <b-field
      :type="{'is-danger': errors.has('button text')}"
      :message="errors.first('button text')"
      label="Button text">
      <b-input
        v-model="header.buttonText"
        v-validate="'required|max:28'"
        name="button text" />
      <p class="character-count">
        Characters: {{ header.buttonText.length }}
      </p>
    </b-field>

    <b-tooltip
      label="De link waar de knop naar moet verwijzen, volledig met http:// etc invullen."
      multilined>
      <i class="info-icon">
        i
      </i>
    </b-tooltip>
    <b-field
      :type="{'is-danger': errors.has('button url')}"
      :message="errors.first('button url')"
      label="Button link">
      <b-input
        v-model="header.url"
        v-validate="'required|url'"
        name="button url" />
    </b-field>
    <b-tooltip
      label="width: 750px, height: 448px, jpg || url voorbeeld: https://images.samsung.com/is/image/samsung/p5/nl/welcome/Wk27_DataDetox_1500x896.jpg"
      multilined>
      <i class="info-icon">
        i
      </i>
    </b-tooltip>
    <b-field
      :type="{'is-danger': errors.has('image url')}"
      :message="errors.first('image url')"
      label="Image (url)">
      <b-input
        v-model="header.imageUrl"
        v-validate="'required|url'"
        name="image url" />
    </b-field>
    <b-tooltip
      label="width: 1500px, height: 896px, jpg"
      multilined>
      <i class="info-icon">
        i
      </i>
    </b-tooltip>
    <b-field
      :type="{'is-danger': errors.has('image url tablet')}"
      :message="errors.first('image url tablet')"
      label="Image tablet (url)">
      <b-input
        v-model="header.imageUrlTablet"
        v-validate="'required|url'"
        name="image url tablet" />
    </b-field>
    <b-field
      label="Button color">
      <b-select
        v-model="header.buttonColor"
        placeholder="Selecteer een kleur"
        expanded>
        <option value="default">
          Black/Trans
        </option>
        <option value="black-full">
          Black/Black
        </option>
        <option value="white">
          White/trans
        </option>
        <option value="white-full">
          White/White
        </option>
      </b-select>
    </b-field>

    <b-field
      label="Logo and settings color">
      <b-select
        v-model="header.logoColor"
        placeholder="Selecteer een kleur"
        expanded>
        <option value="white">
          White
        </option>
        <option value="black">
          Black
        </option>
      </b-select>
    </b-field>

    <div class="field">
      <b-field
        label="Top fade on or off">
        <b-switch v-model="header.topFade">
          {{ header.topFade }}
        </b-switch>
      </b-field>
    </div>

    <div class="field">
      <b-field
        label="Bottom fade on or off">
        <b-switch v-model="header.botFade">
          {{ header.botFade }}
        </b-switch>
      </b-field>
    </div>

    <div class="date-time">
      <b-field label="Start date">
        <b-datepicker
          v-model="dateTime.startDate"
          placeholder="Type or select a date..."
          :min-date="minDate"
          icon="calendar-today" />
      </b-field>
      <b-field label="Starttijd">
        <b-timepicker
          v-model="dateTime.startTime"
          placeholder="Type or select a date..."
          icon="clock" />
      </b-field>
    </div>
    <div class="date-time">
      <b-field label="End date">
        <b-datepicker
          v-model="dateTime.endDate"
          placeholder="Click to select..."
          :min-date="startDateTime || minDate"
          icon="calendar-today" />
      </b-field>
      <b-field label="End time">
        <b-timepicker
          v-model="dateTime.endTime"
          placeholder="Type or select a date..."
          icon="clock" />
      </b-field>
    </div>
    <b-button
      class="submit-button"
      type="is-primary"
      @click="validateBeforeSubmit">
      {{ buttonTitle }}
    </b-button>
  </form>
</template>

<script>
// this is the form sued to edit and create headers,
// it gets a prop with either filled data when editing
// or empty data when creating a new header
import firebase from "firebase/app";
import { db } from "../firebase";

export default {
  name: "HeaderForm",
  props: {
    headerProp: {
      type: Object,
      default: () => {}
    },
    buttonTitle: {
      type: String,
      default: "Create Header"
    }
  },
  data() {
    return {
      dbKey: "headers",
      today: "",
      dateTime: {
        startDate: "",
        startTime: "",
        endDate: new Date(),
        endTime: new Date()
      },
      headers: []
    };
  },
  firestore: {
    headers: db.collection("headers")
  },

  computed: {
    // create new date object from firebase data (needs converting) if available
    startDateTime() {
      if (!this.dateTime.startDate || !this.dateTime.startTime) {
        return "";
      }
      return new Date(
        this.dateTime.startDate.getFullYear(),
        this.dateTime.startDate.getMonth(),
        this.dateTime.startDate.getDate(),
        this.dateTime.startTime.getHours(),
        this.dateTime.startTime.getMinutes(),
        this.dateTime.startTime.getSeconds()
      );
    },
    endDateTime() {
      if (!this.dateTime.endDate || !this.dateTime.endTime) {
        return "";
      }
      return new Date(
        this.dateTime.endDate.getFullYear(),
        this.dateTime.endDate.getMonth(),
        this.dateTime.endDate.getDate(),
        this.dateTime.endTime.getHours(),
        this.dateTime.endTime.getMinutes(),
        this.dateTime.endTime.getSeconds()
      );
    },
    // minimum date for the date picker
    minDate() {
      return new Date(
        this.today.getFullYear(),
        this.today.getMonth(),
        this.today.getDate()
      );
    }
  },
  watch: {
    headerProp() {
      // convert prop on entry into local reactive variables
      this.header = this.headerProp;
      this.dateTime.startTime = this.header.startDate;
      this.dateTime.startDate = this.header.startDate;
      this.dateTime.endTime = this.header.endDate;
      this.dateTime.endDate = this.header.endDate;
    },
    startDateTime() {
      this.header.startDate = this.startDateTime;
    },
    endDateTime() {
      this.header.endDate = this.endDateTime;
    }
  },
  beforeCreate() {
    // check if user is logged in
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        this.$router.push("/login");
      }
    });
  },
  created() {
    const localToday = new Date();
    this.header = this.headerProp;
    this.today = localToday;
    // if no end date cretae 1, 1 week from now
    if (!this.headerProp.endDate) {
      this.dateTime.startTime = this.today;
      this.dateTime.startDate = this.today;
      this.dateTime.endTime = new Date(
        localToday.getFullYear(),
        localToday.getMonth(),
        localToday.getDate() + 7
      );
      this.dateTime.endDate = new Date(
        localToday.getFullYear(),
        localToday.getMonth(),
        localToday.getDate() + 7
      );
    }
  },
  methods: {
    validateBeforeSubmit() {
      // validate all fields
      this.$validator.validateAll().then(result => {
        if (result) {
          // if succes sent an event to the parent component that the form has been validated
          this.$emit("validated", "succes");
          return;
        }
        // or send a toast informing user of failure
        this.$toast.open({
          message: "Form is not valid! Please check the fields.",
          type: "is-danger",
          position: "is-bottom"
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.submit-button {
  margin-top: 1rem;
}

.field.has-addons {
  flex-direction: column;
}

p.character-count {
  margin: 0;
}
</style>